import { ShippingAddress } from '../shipping';

export enum PaymentMethodsType {
  CreditCard = 'Credit Card',
  PayPal = 'PayPal',
  Affirm = 'Affirm',
  Sezzle = 'Sezzle',
  Check = 'Check',
  MoneyOrder = 'Money Order',
  WireTransfer = 'Wire Transfer',
  GiftCard = 'Gift Card',
  Coupon = 'Coupon',
  ApplePay = 'ApplePay',
  GooglePay = 'GooglePay',
}

export type CheckoutPaymentFormData = {
  billingAsShipping: boolean;
  country: string;
  creditCardNumber: string;
  expirationMonth: string;
  expirationYear: string;
  cid: string;
  cardType: string;
  paymentMethod: PaymentMethodsType | null;
} & ShippingAddress;

export type AffirmCheckoutObject = {
  shipping_amount: number;
  tax_amount: number;
  metadata: {
    mode: 'modal' | 'redirect';
  };
  total: number;
  shipping: {
    address: {
      zipcode: number;
      country: string;
      city: string;
      state: string;
      line1: string;
    };
    name: {
      last: string;
      first: string;
    };
  };
  merchant: {
    user_cancel_url: string;
    user_confirmation_url: string;
  };
  config: {
    financial_product_key: string;
  };
  items: Array<{
    item_image_url: string;
    qty: number;
    item_url: string;
    display_name: string;
    sku: string;
    unit_price: number;
  }>;
  order_id: number;
};
